import { CommonModule } from "@angular/common";
import {
  Component,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  SimpleChanges, OnInit, OnChanges,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexXAxis,
  ApexFill,
  ApexTooltip,
  ApexGrid,
  NgApexchartsModule,
} from "ng-apexcharts";
import { NgFor, NgStyle } from "@angular/common";

interface GraphData {
  name: string;
  percentage: number;
  fill: string;
}
@Component({
  selector: "app-payroll-detail",
  standalone: true,
  imports: [CommonModule, NgApexchartsModule, NgFor, FormsModule],
  templateUrl: "./payroll-detail.component.html",
  styleUrls: ["./payroll-detail.component.css"],
})
export class PayrollDetailComponent implements OnInit, OnChanges {
  @ViewChild("allocationChart") allocationChart!: ChartComponent;
  @ViewChild("chart") chart!: ChartComponent;
  @Input() title = "";
  @Input() isStar!: boolean;
  @Input() data: GraphData[] = [];
  @Output() isStarChanged = new EventEmitter<boolean>();
  @Input() selectedTab: "monthly" | "yearly" = "monthly";
  @Input() monthlySalary: number[] = [];
  @Input() yearlySalary: number[] = [];
  @Input() categoriesMonthly: string[] = [];
  @Input() categoriesYearly: string[] = [];
  @Input() salarySummary: any;
  @Output() typeChanged = new EventEmitter<"monthly" | "yearly">();
  @Input() isLoading = true;
  selectedYear: number | null = null;
  @Output() yearSelected: EventEmitter<number> = new EventEmitter<number>();

  years: number[] = [];
  allocationChartOptions: any;

  chartOptions: any = {};

  ngOnInit(): void {
    
    const currentYear = new Date().getFullYear();
    const startYear = 2022;
    for (let year = currentYear; year >= startYear; year--) {
      this.years.push(year);
    }

    this.updateChart();
  }
  ngOnChanges(changes: SimpleChanges) {
    
 if (changes.data && this.data) {
    this.updateAllocationChart();
  }

  // Whenever salary or categories change, update main chart
  if (
    changes.monthlySalary ||
    changes.yearlySalary ||
    changes.categoriesMonthly ||
    changes.categoriesYearly ||
    changes.selectedYear
  ) {
    this.updateChart();
  }
    
  }
  selectTab(tab: "monthly" | "yearly") {
    this.selectedTab = tab;

    // Emit the type to the parent
    this.typeChanged.emit(tab);
    this.updateChart();
  }

  // updateChart() { 
  // let data: number[] = []; 
  // let categories: string[] = []; 
  // if (this.selectedTab === 'monthly') {
  // data = Array.isArray(this.monthlySalary) ? this.monthlySalary : []; 
  //  categories = Array.isArray(this.categoriesMonthly) ? this.categoriesMonthly : []; 
 // } else { 
 // categories = Array.isArray(this.categoriesYearly) ? this.categoriesYearly.map(String) : [];
 // data = categories.map((year:any) => this.yearlySalary[year] ?? 0); 
 // convert object to array  } 
 // if (!data.length || !categories.length) return; 
 // this.chartOptions = { 
 // series: [{ name: 'Salary', data }], 
 //  chart: { type: 'area', height: 350, toolbar: { show: false } }, 
 //  dataLabels: { enabled: false }, 
 //  stroke: { curve: 'smooth', width: 2 }, 
 // fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1, stops: [0, 90, 100] } }, 
 /// xaxis: { categories }, 
 // yaxis: { min: 0, max: data.length ? Math.max(...data) + 5000 : 0, tickAmount: 10, labels: { formatter: (val:any) => ${val.toLocaleString()} }},
 // tooltip: { y: { formatter: (val:any) => PKR ${val.toLocaleString()} }}, // legend: { show: true }, // grid: { show: true, borderColor: '#f3f3f3', strokeDashArray: 0 } // }; // }

updateChart() {
  let data: number[] = [];
  let categories: string[] = [];

  if (this.selectedTab === 'monthly') {
    data = Array.isArray(this.monthlySalary) ? this.monthlySalary : [];
    categories = Array.isArray(this.categoriesMonthly) ? this.categoriesMonthly : [];
  } else {
    // Yearly tab
    if (this.yearlySalary && Object.keys(this.yearlySalary).length > 0) {
      // Multi-year data
      categories = Array.isArray(this.categoriesYearly)
        ? this.categoriesYearly.map(String)
        : [];
      data = categories.map((year: string) => this.yearlySalary[Number(year)] ?? 0);
    } else if (this.monthlySalary && this.monthlySalary.length > 0) {
      // Single year: fallback to monthly data
      data = this.monthlySalary;
      categories = Array.isArray(this.categoriesMonthly) ? this.categoriesMonthly : [];
    } else {
      // No data
      data = [];
      categories = [];
    }
  }

  if (!data.length || !categories.length) return;

  const maxVal = Math.max(...data);

  this.chartOptions = {
    series: [{ name: 'Salary', data }],
    chart: { type: 'area', height: 350, toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1, stops: [0, 90, 100] } },
    xaxis: { categories },
    yaxis: {
      min: 0,
      max: maxVal + Math.round(maxVal * 0.1),
      labels: { formatter: (val: number) => this.isStar ? '*****' : val.toLocaleString() }
    },
    tooltip: {
      y: {
        formatter: (_val: number, opts: { dataPointIndex: number }) =>
          this.isStar ? '*****' : `PKR ${data[opts.dataPointIndex].toLocaleString()}`
      }
    },
    legend: { show: true },
    grid: { show: true, borderColor: '#f3f3f3', strokeDashArray: 0 }
  };
}




  updateAllocationChart() {
    if (!this.data?.length) return;

    this.allocationChartOptions = {
      series: this.data.map((d) => d.percentage),
      chart: {
        type: "pie",
        height: 318,
      },
      labels: this.data.map((d) => d.name),
      fill: {
        opacity: 0.8,
        colors: this.data.map((d) => d.fill),
      },
      stroke: {
        colors: ["#fff"],
      },
      tooltip: {
        enabled: true,
        y: { formatter: (val: number) => `${val}%` }, // show value only on hover
      },
      legend: {
        show: false, // hide legend
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false, // remove numbers inside slices
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 200 },
            legend: { show: false },
          },
        },
      ],
    };
  }

  // sendFalse() {
  //   this.isStar = false;
  //   this.isStarChanged.emit(this.isStar);
  //   sessionStorage.setItem("isStar", "false");
  //       this.updateChart();
  // }

sendFalse() {
  this.isStar = !this.isStar;  // Toggle true/false
  this.isStarChanged.emit(this.isStar);  // Send value to parent
  sessionStorage.setItem("isStar", this.isStar.toString());
  this.updateChart();
}
  onYearChange(year: number) {
    ;
    console.log("Selected year:", year); // now it will log the correct year
    this.yearSelected.emit(year);
  }


  
}
